/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Credit_BlockedInputs */

const en_so_credit_blocked = /** @type {(inputs: So_Credit_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit blocked`)
};

/**
* | output |
* | --- |
* | "Credit blocked" |
*
* @param {So_Credit_BlockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_credit_blocked = /** @type {((inputs?: So_Credit_BlockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Credit_BlockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_credit_blocked(inputs)
});